import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { DynamicDetailComponent } from '../../../dynamic-entity/components/dynamic-detail/dynamic-detail.component';

import { environment } from '../../../../environments/environment';

import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent extends DynamicDetailComponent implements OnInit, AfterViewInit {

  public mainForm: FormGroup;
  private customerTypes = [];

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected location: Location,
    private fb: FormBuilder, protected toastr: ToastrService, private http: Http) {

    super(baseservice, metadataservice, router, route, location, toastr);
  }

  ngOnInit() {
    super.ngOnInit();

    this.mainForm = this.fb.group({
      //Id: null,
      Designation: [null, Validators.required],
      CustomerTypeID: null,
      NIF: null,
      Address: null,
      Town: null,
      PostalCode: null,
      Inactive: [false, Validators.required],
      Templates: null
    });

    this.getCustomerTypes();
  }

  ngAfterViewInit() {
    let previousValid = this.mainForm.valid;
    this.mainForm.valueChanges.subscribe(() => {
      if (this.mainForm.valid !== previousValid) {
        previousValid = this.mainForm.valid;
        this.status.canSave = previousValid;
      }
    });
    this.status.canSave = previousValid;
  }

  protected setValues(values) {
    this.item = values;
    this.status.canDelete = true;
    this.mainForm.patchValue(this.item);
  }

  public save(event) {

    const formModel = this.mainForm.value;
    this.item = Object.assign(this.item, formModel);

    this.baseservice.save(this.item)
      .subscribe(return_value => {
        if (return_value !== true) {
          this.item = return_value;
        }
        this.location.back();
      },
      error => {
        this.error = error;
        console.log('Error saving:' + error);
      });
  }

  public requestAutocompleteItems = (text: string): Observable<Response> => {

    // this.baseservice.search(text)
    //   .subscribe(return_value => return_value,
    //   error => console.log('Error searching: ' + error));

    return this.http
      .get(API_URL + '/Templates?search=' + text)
      .map(data => data.json().map(item => item));

  }

  private getCustomerTypes() {
    this.baseservice.setEntity('CustomerTypes');
    this.baseservice.getAll().subscribe(
      data => {
        this.customerTypes = data;
        this.customerTypes.unshift({'Id': -1, 'Designation': ''});
    });
    this.baseservice.setEntity(this.entity);
  }}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/customers/customer.component.ts